/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { Collapse } from 'antd'
import dayjs from 'dayjs'
import { Lose, MoneyHistoryItemWrap } from '@views/MyBank/index.style'
import { Schema$UserActivityTrack } from '@interface/user-activity'
import { observer } from 'mobx-react'
import { USER_ACTIVITY_TYPE } from '@v2/constants/activity'
import useRootStore from '@store/useRootStore'
import { GlobalStoreKey } from '@v2/constants/common'

interface ActivityScoreListItemProp {
  track: Schema$UserActivityTrack
}

export const ActivityHistoryItem: React.FC<ActivityScoreListItemProp> = observer((props) => {
  const { track } = props
  const activities = track.activities || []
  const { globalStore } = useRootStore()

  const imageUrl = globalStore.findGlobalSetting(GlobalStoreKey.INGAME_IMAGES_URL).value
  const version = globalStore.getIngameImagesVersion()
  const communityProfileImgUrl = `${imageUrl}icon/community_profile.png${version}`
  const companyPickProfileImgUrl = `${imageUrl}icon/premium_analyst_profile.png${version}`
  const userPickProfileImgUrl = `${imageUrl}icon/user_pick_profile.png${version}`


  const header = activities.map(activity => {
    let activityImg: React.ReactElement
    let activityDesc: string
    switch (activity.activityType) {
      case USER_ACTIVITY_TYPE.BET_HISTORY_SHARED_TO_CHAT:
        activityImg = <img src={communityProfileImgUrl} alt="채팅" className="location"/>
        activityDesc = '채팅 베팅내역 공유'
        break
      case USER_ACTIVITY_TYPE.COMPANY_PICK_COMMENT:
        activityImg = <img src={companyPickProfileImgUrl} alt="프리미엄 분석가" className="location"/>
        activityDesc = '댓글 및 답글 작성'
        break
      case USER_ACTIVITY_TYPE.COMPANY_PICK_LIKED:
        activityImg = <img src={companyPickProfileImgUrl} alt="프리미엄 분석가" className="location"/>
        activityDesc = '분석글 좋아요'
        break
      case USER_ACTIVITY_TYPE.TODAY_USER_PICK:
        activityImg = <img src={userPickProfileImgUrl} alt="나도 승부사" className="location"/>
        activityDesc = '오늘의 승부사 선정'
        break
      case USER_ACTIVITY_TYPE.USER_PICK_COMMENT:
        activityImg = <img src={userPickProfileImgUrl} alt="나도 승부사" className="location"/>
        activityDesc = '댓글 및 답글 작성'
        break
      case USER_ACTIVITY_TYPE.USER_PICK_LIKED:
        activityImg = <img src={userPickProfileImgUrl} alt="나도 승부사" className="location"/>
        activityDesc = '분석글 좋아요'
        break
      case USER_ACTIVITY_TYPE.USER_PICK_RECEIVED_COMMENT:
        activityImg = <img src={userPickProfileImgUrl} alt="나도 승부사" className="location"/>
        activityDesc = '내 분석글 댓글 및 답글'
        break
      case USER_ACTIVITY_TYPE.USER_PICK_RECEIVED_LIKE:
        activityImg = <img src={userPickProfileImgUrl} alt="나도 승부사" className="location"/>
        activityDesc = '내 분석글 좋아요'
        break
      case USER_ACTIVITY_TYPE.USER_PICK_WRITTEN:
        activityImg = <img src={userPickProfileImgUrl} alt="나도 승부사" className="location"/>
        activityDesc = '분석글 작성'
        break
      case USER_ACTIVITY_TYPE.CHEER_FOR_TEAM:
        activityImg = <img src={communityProfileImgUrl} alt="나도 승부사" className="location"/>
        activityDesc = '응원글 작성'
        break
    }
    let scoreText = `+${activity.activityScore}점`
    if (activity.activityScore < 0) {
      scoreText = `${activity.activityScore}점`
    }

    return (
      <div className="active-score-history-list" key={`user-activity-history-item-${activity.id}`}>
        <div className="active-score-history-list--wrap">
          {activityImg}
          <div className="txt-time-wrap">
            <span className="active-score-history-list--wrap--txt">{activityDesc}</span>
            <span className="active-score-history-list--wrap--time">{dayjs(activity.createdAt).format('HH:mm:ss')}</span>
          </div>
        </div>
        <div className="active-score-history-list--wrap num">
          <span className="active-score-history-list--wrap--num" css={activity.activityScore < 0 && Lose}>{scoreText}</span>
          {activity.activityScore < 0 && <span className="score-return-tag">관리자 회수</span>}
        </div>
      </div>
    )
  })

  return (
    <MoneyHistoryItemWrap>
      <div className="date-wrap activity-score">
        {dayjs(track.activityDate).format('MM.DD(ddd)')}
        <span className={"score-summary"}>{track.activityScoreSummary}점</span>
      </div>
      <Collapse bordered={false} defaultActiveKey="0" className="active-score-history">
        <Collapse.Panel key={track.activityDate} header={header} showArrow={false} disabled={true}/>
      </Collapse>
    </MoneyHistoryItemWrap>
  )
})
